const environment = {
    baseApiUrl: 'https://club-back-3e51f618fcba.herokuapp.com/',
    baseBooksUrl: 'https://books-biblio-d43e5e58b1a6.herokuapp.com/'
}

export default environment;
